import React from 'react';
import PropTypes from 'prop-types';
import { FormSection } from 'redux-form';

import { PAC_FORM_TYPES } from './constants/common';

export default function PlacementForm(props) {
	const {
		placementType,
		children,
	} = props;

	if(placementType === PAC_FORM_TYPES.DEFAULT){
		return children;
	}

	return (
		<FormSection name={`placements.${placementType}`}>
			{children}
		</FormSection>
	);
}

PlacementForm.propTypes = {
	placementType: PropTypes.string.isRequired,
};
